import React, { useState } from "react";
import FluentUiIcon from "../../../../../../assets/fluent-ui-icon";
import { GetIconForField } from "../form-design/form-design-util";
import { CreateEditField } from "../common-components/create-edit-field";
import PropTypes from "prop-types";

export const TaskLayoutSectionItem = ({
  field,
  index,
  SaveField,
  DeleteField,
}) => {
  const [dialog, setDialog] = useState(false);
  return (
    <div className="task-layout-content-section-field">
      <div className="task-layout-content-section-field-info">
        <div className="task-layout-content-section-field-info-number">
          {index + 1}
        </div>
        <div className="task-layout-content-section-field-info-icon">
          <FluentUiIcon
            name={GetIconForField(field.FieldType)}
            color={"#605E5C"}
            size={20}
          />
        </div>
        {field.LocalLabel}
      </div>
      <div onClick={() => setDialog(true)}>
        <FluentUiIcon
          name={"ChevronRightRegular"}
          color={"#605E5C"}
          size={20}
        />
      </div>
      {dialog && (
        <CreateEditField
          field={field}
          open={dialog}
          OnCancel={() => setDialog(false)}
          SaveField={(field) => {
            SaveField(field);
            setDialog(false);
          }}
          DeleteField={(field) => {
            DeleteField(field);
            setDialog(false);
          }}
        />
      )}
    </div>
  );
};

TaskLayoutSectionItem.propTypes = {
  field: PropTypes.object,
  index: PropTypes.number,
  SaveField: PropTypes.func,
  DeleteField: PropTypes.func,
};
